import { useEffect } from "react"
import { useLocation, useSearchParams } from "react-router-dom"

export default function SignInTypePage() {

  const location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    
    const hash = location.hash.substring(1)
    const query = new URLSearchParams(hash)

    const error = query.get('error')

    if(error) alert('error')
    else {
      const accessToken = query.get('access_token')
      
      window.opener.postMessage({
        accessToken: accessToken
      }, '*')
    }

    window.close()
  }, [location])

  return <></>
}